import { useEffect } from "react";
import i18n from "../config";
import { isI18nEnabled } from "../feature-flag";

/**
 * Hook für SEO-Optimierungen basierend auf der aktuellen Sprache.
 *
 * Setzt das HTML lang-Attribut dynamisch basierend auf der i18n-Sprache.
 *
 * Verwendung: In App.tsx oder Root-Komponente: `useSEO();`
 */
export function useSEO() {
  const enabled = isI18nEnabled();

  useEffect(() => {
    if (!enabled) {
      // Feature deaktiviert → Standard Deutsch
      document.documentElement.lang = "de";
      return;
    }

    // HTML lang-Attribut setzen
    const updateLang = () => {
      document.documentElement.lang = i18n.language || "de";
    };

    // Initial setzen
    updateLang();

    // Auf Sprachänderungen reagieren
    i18n.on("languageChanged", updateLang);

    // Cleanup
    return () => {
      i18n.off("languageChanged", updateLang);
    };

    // Title (optional, kann pro Route überschrieben werden)
    // document.title = i18n.t('meta.title', { ns: 'common' });
  }, [enabled]);
}
